import { render } from "./AccountProfileForm.vue?vue&type=template&id=86e2ba7a"
import script from "./AccountProfileForm.vue?vue&type=script&lang=js"
export * from "./AccountProfileForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\supportgroup\\head.supportgroup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__